/**
 * ErrorBoundary — rete di sicurezza contro le schermate bianche.
 * Un'eccezione non gestita in un componente smontava tutto l'albero React
 * lasciando la pagina vuota (segnalato in produzione su "Nuovo ordine").
 * Ora mostra un messaggio leggibile con azioni di recupero.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Errore non gestito nella UI:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="error-boundary">
        <div className="max-w-lg w-full bg-white border border-slate-200 p-6">
          <div className="flex items-center gap-2 mb-3">
            <AlertTriangle className="w-5 h-5 text-amber-600" />
            <h1 className="font-heading font-bold text-lg">Qualcosa è andato storto</h1>
          </div>
          <p className="text-sm text-slate-600 mb-1">
            La pagina ha incontrato un errore inatteso. I tuoi dati sono al sicuro:
            puoi ricaricare e riprovare.
          </p>
          <p className="text-xs text-slate-400 font-mono mb-5 break-words" data-testid="error-boundary-detail">
            {String(this.state.error?.message || this.state.error)}
          </p>
          <div className="flex gap-2">
            <Button className="rounded-none" onClick={() => window.location.reload()}
                    data-testid="error-boundary-reload">Ricarica la pagina</Button>
            <Button variant="outline" className="rounded-none"
                    onClick={() => { window.location.href = '/'; }}
                    data-testid="error-boundary-home">Torna alla home</Button>
          </div>
        </div>
      </div>
    );
  }
}
